import { environment } from "../utils/environment";
import { Sku } from "../types/Sku";
import { NftMetaData } from "types/ResourcePackNft";

const baseFetch = <T>(endpoint: string) => {
  return new Promise<T>((resolve, reject) => {
    fetch(environment.mongo_api_base_url + endpoint)
      .then((resp) => resp.json())
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getVipStakingLevels = () => {
  return baseFetch<any>("/configs/vipbenefits");
};

export const getSkuList = () => {
  return baseFetch<Sku[]>("/skulist");
};

export const getServerTime = async () => {
  const serverTimestamp = await baseFetch<number>("/configs/time");
  return serverTimestamp || null;
};

export const getResourceBundleNftMetadata = async (tokenId: string) => {
  const nftMetadata = await baseFetch<NftMetaData>(
    `/nfts/resource_bundle/metadata?token_id=${tokenId}`
  );
  return nftMetadata;
};

export const getNftMetadataFromServer = async (tokenId: string) => {
  const landMetadata = await baseFetch<any>(
    `/nfts/metadata?TokenId=${tokenId}`
  );
  return landMetadata;
}
